import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function BuyCryptoAltMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M12 21.36c5.256 0 9.36-4.272 9.36-9.36 0-5.232-4.128-9.36-9.36-9.36-5.232 0-9.36 4.128-9.36 9.36 0 5.232 4.128 9.36 9.36 9.36zM4.56 12c0-4.176 3.264-7.44 7.44-7.44s7.44 3.264 7.44 7.44c0 4.056-3.264 7.44-7.44 7.44S4.56 16.176 4.56 12zm3.672 1.416c-.048 1.8 1.248 3.12 3.12 3.36v1.2h1.32v-1.2c1.824-.24 3.12-1.44 3.12-3 0-1.464-1.008-2.304-2.688-2.544l-1.56-.216c-.936-.12-1.296-.36-1.296-1.08 0-.96.576-1.2 1.776-1.2 1.344 0 1.728.336 1.704 1.536h1.848c0-1.56-1.224-2.832-2.904-3.096v-1.2h-1.32v1.2c-1.704.24-2.856 1.416-2.856 2.88 0 1.416.864 2.232 2.424 2.448l1.56.216c1.08.144 1.44.408 1.44 1.2 0 1.008-.504 1.272-1.896 1.272-1.584 0-2.016-.384-1.992-1.776h-1.8z"  /></Svg>;
}
export default BuyCryptoAltMedium;